// File created by Reginald Sahil Chand on 26-03-2024.

import React, {type ReactNode, type ReactElement} from 'react';

import {CreateTask} from './create_tasks/CreateTask';
import {AllTasks} from './all_tasks/AllTasks';

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 * 
 * @version 0.1.0
 *
 * @see src/modules/TaskManagementSystem.tsx
 * @see src/components/layouts/widgets/navigation/TaskNavigation.tsx
 * @property {number} activeIndexState - The current clicked state index of the user based on the
		  navigation link onclick.
 */
type TasksProps = {
	activeIndexState: number;
};

/**
 * @author Reginald Sahil Chand
 * @email Developer.ReginaldSahilChand@gmail.com
 *
 * @description Render components related to Task Management.
 *
 * @type {TasksProps}
 * @version 0.1.0
 *
 * @returns {JSX Element} Tasks component.
 */
export const Tasks: React.FC<TasksProps> = React.memo(
	({activeIndexState}: TasksProps): ReactElement => {
		/**
		 * @author Reginald Sahil Chand
		 * @email Developer.ReginaldSahilChand@gmail.com
		 *
		 * @description TODO: Update description and optimize component renderer function.
		 * @version 0.1.0
		 *
		 * @returns {ReactNode} React component.
		 */
		const componentRenderer: () => ReactNode = (): ReactNode => {
			if (activeIndexState === 0) {
				return <CreateTask />;
			}

			if (activeIndexState === 1) {
				return <AllTasks />;
			}
		};

		return <section className="relative bg-tasksContainer">{componentRenderer()}</section>;
	},
);

Tasks.displayName = 'Tasks';
